import { select } from '@syncfusion/ej2-base';
import * as events from '../base/constant';
import * as model from '../models/items';
import * as classes from '../base/classes';
import { RenderType } from '../base/enum';
import { getIndex } from '../base/util';
export class MenuButton {
    constructor(parent, serviceLocator) {
        this.isDestroyed = false;
        this.parent = parent;
        this.locator = serviceLocator;
        this.i10n = serviceLocator.getService('rteLocale');
        this.renderFactory = this.locator.getService('rendererFactory');
        this.addEventListener();
        this.initRender = true;
    }
    addEventListener() {
        this.parent.on(events.rtlMode, this.setRtl, this);
        this.parent.on(events.bindCssClass, this.setCssClass, this);
    }
    renderMenu(toolbarItems, toolbarElement, containerType) {
        this.toolbarRenderer = this.renderFactory.getRenderer(RenderType.Toolbar);
        model.templateItems.forEach((item) => {
            if (getIndex(item, toolbarItems) !== -1) {
                switch (item) {
                    case 'aicommands': {
                        const menuName = item;
                        const rootElement = select('#' + this.parent.getID() + '_' + containerType.toLowerCase() + '_AICommandsDropDownMenu', toolbarElement);
                        const ulElement = this.parent.createElement('ul', { id: this.parent.getID() + '_' + containerType.toLowerCase() + '_AICommandsMenu' });
                        rootElement.appendChild(ulElement);
                        const argument = {
                            dropDownItems: {
                                iconCss: 'e-ai-chat e-icons',
                                cssClass: classes.CLS_DROPDOWN_POPUP + ' ' + classes.CLS_DROPDOWN_ITEMS + ' ' + classes.CLS_AI_COMMANDS_TBAR_BTN + ' ' + classes.CLS_DROPDOWN_MENU,
                                target: '#' + ulElement.id
                            },
                            menuItems: {
                                items: this.parent.aiAssistantSettings.commands
                            },
                            name: menuName,
                            containerType: containerType,
                            toolbarElement: toolbarElement,
                            dropDownRoot: rootElement,
                            menuRoot: ulElement
                        };
                        const { menu, dropDownButton } = this.toolbarRenderer.renderMenu(argument);
                        this.aiCommandsMenu = menu;
                        this.aiCommandsDropDownButton = dropDownButton;
                        break;
                    }
                }
            }
        });
    }
    setRtl(args) {
        if (this.aiCommandsMenu) {
            this.aiCommandsMenu.setProperties({ enableRtl: args.enableRtl });
            this.aiCommandsDropDownButton.setProperties({ enableRtl: args.enableRtl });
        }
    }
    setCssClass(args) {
        if (this.aiCommandsMenu && !this.initRender) {
            this.aiCommandsMenu.setProperties({ cssClass: args.cssClass + ' e-rte-aicommands-menu' + 'e-rte-menu ' + classes.CLS_RTE_ELEMENTS });
            this.aiCommandsDropDownButton.setProperties({ cssClass: args.cssClass + '' + classes.CLS_DROPDOWN_POPUP + ' ' + classes.CLS_DROPDOWN_ITEMS + ' ' + classes.CLS_AI_COMMANDS_TBAR_BTN + ' ' + classes.CLS_DROPDOWN_MENU });
        }
        else {
            this.initRender = false;
        }
    }
    destroyMenu() {
        if (this.aiCommandsMenu && !this.aiCommandsMenu.isDestroyed) {
            this.aiCommandsMenu.destroy();
            this.aiCommandsDropDownButton.destroy();
            this.aiCommandsMenu = null;
            this.aiCommandsDropDownButton = null;
        }
    }
    removeEventListener() {
        this.parent.off(events.rtlMode, this.setRtl);
        this.parent.off(events.bindCssClass, this.setCssClass);
    }
    destroy() {
        if (this.isDestroyed) {
            return;
        }
        this.removeEventListener();
        this.destroyMenu();
        this.isDestroyed = true;
    }
}
